import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS, SpinOptions } from './config';
import { Form, NumberInputFrom } from '@tencent/wb-ext-form';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { ISlideFooterFeature } from '@framework/workbench/drawer/ui/slide-footer/slide-footer-interface';
import { DatetimeFieldType } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/format-datetime';
import { DatetimeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-footer/slide-footer.interface';

@Controller({ formItems: FORM_CONFIGS })
export class SlideFooterController {
    constructor(@Loader(ISlideFooterFeature) private loader: IDynamicLoader<ISlideFooterFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.SLIDE_NUMBER, 'content')
    public getSlideNumberContent(): string {
        return this.feature.getSlideNumberContent();
    }

    @Form(FormItemName.SLIDE_NUMBER_START, 'value')
    public getSlideNumberStartIndex(): number {
        return this.feature.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.SLIDE_FOOTER,
            { slideNumber: this.feature.getSlideNumberStartIndex() },
        )  as number;
    }

    @Form(FormItemName.SLIDE_NUMBER_START, 'onChange')
    public updateSlideNumberStartIndex(value: number, from?: NumberInputFrom): void {
        const { slideNumber } = this.feature.getValidValue(
            { slideNumber: value }, from,
            SpinOptions.max, SpinOptions.min,
        );
        this.feature.updateSlideNumberStartIndex(slideNumber);
    }

    @Form(FormItemName.SLIDE_NUMBER_START, 'shouldDisabled')
    public shouldSlideNumberStartDisabled(): boolean {
        return this.feature.shouldSlideNumberStartDisabled();
    }

    @Form(FormItemName.SLIDE_FOOTER, 'content')
    public getSlideFooterContent(): string {
        return this.feature.getSlideFooterContent();
    }

    @Form(FormItemName.SLIDE_FOOTER_INPUT, 'content')
    public getSlideFooterInputContent(): string {
        return this.feature.getSlideFooterInputContent();
    }

    @Form(FormItemName.DATETIME, 'content')
    public getDatetimeContent(): string {
        return this.feature.getDatetimeContent();
    }

    @Form(FormItemName.DATETIME_TYPE_SELECT, 'onChange')
    public updateDatetimeType(value: DatetimeType) {
        return this.feature.updateDatetimeType(value);
    }

    @Form(FormItemName.DATETIME_TYPE_SELECT, 'value')
    public getDatetimeType() {
        return this.feature.getDatetimeType();
    }

    @Form(FormItemName.DATETIME_TYPE_SELECT, 'shouldDisabled')
    public shouldDatetimeTypeDisabled() {
        return this.feature.shouldDatetimeOthersDisabled();
    }

    @Form(FormItemName.DATETIME_FIELD_TYPE_SELECT, 'onChange')
    public updateDatetimeFieldType(value: DatetimeFieldType) {
        return this.feature.updateDatetimeFieldType(value);
    }

    @Form(FormItemName.DATETIME_FIELD_TYPE_SELECT, 'value')
    public getDatetimeFieldType() {
        return this.feature.getDatetimeFieldType();
    }

    @Form(FormItemName.DATETIME_FIELD_TYPE_SELECT, 'shouldDisabled')
    public shouldDatetimeFieldTypeDisabled() {
        return this.feature.shouldDatetimeOthersDisabled();
    }

    @Form(FormItemName.DATETIME_INPUT, 'content')
    public getDatetimeInputContent(): string {
        return this.feature.getDatetimeInputContent();
    }

    @Form(FormItemName.FOOTER_APPLY, 'onClick')
    public handleApplyButtonClick(): void {
        return this.feature.handleApplyButtonClick();
    }
}
